<template>
  <div>
    <div class="header_wrap">
      <div style="width: 60%">
        <el-steps style="width: 100%" align-center :active="0">
          <el-step title="海运信息"></el-step>
          <el-step title="增值服务"></el-step>
          <el-step title="托运信息"></el-step>
          <el-step title="确认委托"></el-step>
          <el-step title="委托完成"></el-step>
        </el-steps>
      </div>
    </div>
    <!-- --------------------------------内容 -->
    <div class="center_wrap">
      <div class="wrap_l">
        <!-- ---送货上门--- -->
        <div class="Item_list">
          <div class="cangkutit" style="margin-right: 50px">
            {{ fromFABck.namec }}
          </div>
          <div class="cangkutit" style="margin-right: 50px">
            <img v-show="transportTypeCode=='KY'" style="width: 60px"
            src=../../../static/images/KY.png alt="空运" /> <img
            v-show="transportTypeCode=='HY'" style="width: 60px"
            src=../../../static/images/HY.png alt="海运" /> <img
            v-show="transportTypeCode=='LY'" style="width: 60px"
            src=../../../static/images/LY.png alt="陆运" />
          </div>
          <div class="cangkutit">
            {{ toFABck.country }}
            <span style="font-size: 14px">{{ toFABck.namec }}</span>
          </div>
        </div>
        <!-- ---上门提货--- -->
        <div class="Item_list" style="padding: 20px 0px 0px 0px">
          <div style="width: 100%; margin-bottom: 20px">
            <el-checkbox v-model="THFdata.checked" @change="changeTi"
              >发货地上门提货</el-checkbox
            >
          </div>
          <div style="width: 100%; float: left" v-show="THFdata.checked">
            <div style="padding: 10px 0 0 25px; box-sizing: border-box">
              <el-form
                label-position="left"
                label-width="80px"
                :model="THFdata"
              >
                <el-form-item label="提货地点" size="">
                  <!-- <el-input v-model="newTihuoarr"></el-input> -->
                  <div
                    @click="changeCheic()"
                    style="
                      width: 344px;
                      height: 36px;
                      background: #ffffff;
                      border: 1px solid #e7e7e7;
                      border-radius: 5px;
                    "
                  >
                    <span style="float: left"
                      ><i
                        style="font-size: 16px; padding: 0 5px"
                        class="el-icon-location-outline"
                      ></i
                    ></span>
                    <span
                      style="
                        width: 290px;
                        height: 33px;
                        overflow: hidden;
                        display: inline-block;
                      "
                      >{{ countLIst_T.parvince }}{{ countLIst_T.city
                      }}{{ countLIst_T.area }}{{ countLIst_T.address }}</span
                    >
                    <span style="float: right"
                      ><i class="el-icon-arrow-right"></i
                    ></span>
                  </div>
                </el-form-item>
                <el-form-item label="提货日期">
                  <div class="block">
                    <el-date-picker
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      style="width: 344px"
                      v-model="todoorTime"
                      type="date"
                      placeholder="选择日期"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </div>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>

        <div class="demoLIst">
          <div style="width: 98%; float: left">
            <div
              class="LR_center"
              style="font-size:18px;margin-top:24px;float:left:width:100%;font-weight:bold; "
            >
              <div
                style="
                  display: flex;
                  flex-flow: row nowrap;
                  align-items: center;
                "
              >
                <img
                  style="width: 20px; height: 22px"
                  src="../../assets/boxicon.png"
                  alt=""
                />
                <span style="margin-left: 10px">商品信息</span>
              </div>
              <el-button
                type="primary"
                @click="(excelVisible = true), (errorLabel = [])"
                size="mini"
                :close-on-click-modal="false"
                >导入箱子<i class="el-icon-upload el-icon--right"></i
              ></el-button>
            </div>
            <el-form
              label-position="left"
              class="demo-dynamic"
              size="mini"
              :model="ruleform"
              ref="ruleform"
            >
              <div
                class="cardWrap"
                v-for="(item, index) in ruleform.formLIst"
                :key="index"
              >
                <div class="box-card">
                  <div class="card_header">
                    <div class="boxindex">
                      {{ index + 1 }}
                    </div>
                    <div class="header_logo" style="cursor: pointer">
                      <div class="cloneType" @click="clone(item)">复制</div>
                      <div
                        class="deleteBtn"
                        v-if="ruleform.formLIst.length > 1"
                        @click="handleDelete(index, item)"
                      >
                        <i class="el-icon-error"></i>
                      </div>
                    </div>
                    <div class="">
                      <el-row :gutter="5" class="">
                        <!-- <el-col :span="6">
                          <el-form-item
                            label-width="78px"
                            class="rules"
                            label="商品类型"
                            :prop="'formLIst.' + index + '.goodstypeid'"
                            :rules="moreNotOjb.Nottypeid"
                          >
                            <el-select
                              style="width: 100%"
                              ref="changeFBAgoodtype"
                              v-model="item.goodstypeid"
                              placeholder="请选择"
                              @change="changeGStype(item.goodstypeid, index)"
                            >
                              <el-option
                                v-for="res in goodstypelist"
                                :key="res.id"
                                :label="res.cnName"
                                :value="res.id"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col> -->
                        <el-col :span="12">
                          <el-col :span="12">
                            <el-form-item
                              label="尺寸(CM)"
                              label-width="86px"
                              class="rules"
                              :prop="'formLIst.' + index + '.length'"
                              :rules="moreNotOjb.Notlength"
                            >
                              <el-input
                                placeholder="长"
                                size="mini"
                                :min="0"
                                :max="9999"
                                v-model="item.length"
                                @change="getTimoney(index), getFBATrans(index)"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <el-form-item
                              class="rules"
                              label-width="5px"
                              :prop="'formLIst.' + index + '.width'"
                              :rules="moreNotOjb.Notwidth"
                            >
                              <el-input
                                placeholder="宽"
                                size="mini"
                                :min="0"
                                :max="9999"
                                v-model="item.width"
                                @change="getTimoney(index), getFBATrans(index)"
                              >
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="6">
                            <el-form-item
                              label-width="5px"
                              class="rules"
                              :prop="'formLIst.' + index + '.height'"
                              :rules="moreNotOjb.Notheight"
                            >
                              <el-input
                                placeholder="高"
                                size="mini"
                                :min="0"
                                :max="9999"
                                v-model="item.height"
                                @change="getTimoney(index), getFBATrans(index)"
                              >
                              </el-input>
                            </el-form-item>
                          </el-col>
                        </el-col>
                        <el-col :span="5">
                          <div
                            class="LR_center"
                            style="
                              font-size: 12px;
                              font-weight: bold;
                              text-align: left;
                              margin-top: 8px;
                            "
                          >
                            <div style="">
                              <span style="color: #f86670">{{ item.cbm }}</span>
                              CBM
                            </div>
                            <!-- <div style="margin-right: 5px">
                              <span style="color: #e6a23c">{{
                                item.goodsDTOList ? item.goodsDTOList.length : 0
                              }}</span>
                              件商品
                            </div> -->
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                  <div class="card_count">
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <el-form-item
                          class="rules"
                          label-width="78px"
                          label="箱号"
                          :rules="moreNotOjb.Notboxnum"
                          :prop="'formLIst.' + index + '.fbxBoxNo'"
                        >
                          <el-input
                            maxlength="19"
                            type="text"
                            :placeholder="
                              billType ? '示例：FBAXXXXX' : '请输入箱号'
                            "
                            v-model="item.fbxBoxNo"
                            size="mini"
                          >
                            <el-button
                              v-if="billType"
                              slot="suffix"
                              @click="(imageNum = 1), (imagesType = true)"
                              type="text"
                              >示例图</el-button
                            >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item
                          label-width="95px"
                          class="rules"
                          label="重量"
                          :prop="'formLIst.' + index + '.weight'"
                          :rules="moreNotOjb.Notweight"
                        >
                          <el-input
                            size="mini"
                            @change="getTimoney(), getFBATrans(index)"
                            :min="0"
                            :max="999"
                            v-model="item.weight"
                            placeholder="请输入重量"
                          >
                            <i slot="suffix">(KG)</i>
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <!-- <el-col
                        :span="12"
                        v-if="billType && toFABck.countryCode == 'SA'"
                      >
                        <el-form-item
                          class="rules"
                          label-width="78px"
                          label="商铺号"
                          :prop="'formLIst.' + index + '.shopName'"
                          :rules="moreNotOjb.Notgoodsnum"
                        >
                          <el-input
                            v-model="item.shopName"
                            size="mini"
                          ></el-input>
                        </el-form-item>
                      </el-col> -->
                      <el-col
                        :span="12"
                        v-if="billType && toFABck.countryCode == 'SA'"
                      >
                        <el-form-item
                          class="rules"
                          label-width="95px"
                          label="货件追踪号"
                          :prop="'formLIst.' + index + '.poTrackingNo'"
                          :rules="moreNotOjb.Notponum"
                        >
                          <el-input
                            size="mini"
                            maxlength="8"
                            v-model="item.poTrackingNo"
                            placeholder="示例：618T8E8X"
                          >
                            <el-button
                              slot="suffix"
                              @click="(imageNum = 2), (imagesType = true)"
                              type="text"
                              >示例图</el-button
                            >
                          </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                  <div
                    style="
                      width: 100%;
                      padding: 5px 20px;
                      box-sizing: border-box;
                    "
                  >
                    <!-- <div style="width:100%;padding-left:75px;">
                         <div class="goodLi" style="width:500px" v-for="(_item,_index) in item.goodsDTOList" :key="_index">
                            <div style="width:30px;float:left"><i style="font-size:18px" class="el-icon-shopping-cart-1"></i></div>
                            <div style="width:200px;float:left;overflow: hidden;color:#999999;font-weight: bold;font-size:12px"><span style="width:100px">{{_item.namec}} </span> <span style="margin-left:10px">({{_item.namee}})</span></div>
                            <div style="float:left;margin-left:20px" class="handNumber">
                              <el-input size="mini" v-model.number="_item.num" type="number" @change="handleChange" minlength="1" maxLength='9'>
                                 <i slot="prefix" class="el-input__icon el-icon-plus" @click="_item.num+=1"></i>
                                 <i slot="suffix" class="el-input__icon el-icon-minus" @click="_item.num-=1,_item.num<=1?_item.num=1:''"></i>
                              </el-input>
                            </div>
                            <div style="float:left;margin-left:20px" >
                              <el-button class="el-icon-delete" style="color:#f86670" type="text" size="mini" @click="delBoxgood(index,_index)">删除</el-button>
                            </div>
                         </div>
                      </div> -->
                    <!-- 折叠 -->
                    <el-collapse
                      @change="handleOPen(index)"
                      v-model="activeName"
                      style="float:left:width:100%"
                    >
                      <el-collapse-item :name="index">
                        <template slot="title">
                          <i class="el-icon-coin"></i>
                          <span
                            style="
                              margin-left: 15px;
                              font-size: 13px;
                              font-weight: bold;
                            "
                            >{{ item.goodsDTOList.length }}箱商品</span
                          >
                          <span
                            class="el-icon-info"
                            style="
                              margin-left: 30px;
                              font-size: 12px;
                              color: #999;
                            "
                            >请根据实际情况填写商品货值</span
                          >
                        </template>
                        <div
                          @click="clickme(_item)"
                          class="goodLi"
                          style="width: 100%"
                          v-for="(_item, _index) in item.goodsDTOList"
                          :key="_index"
                        >
                          <div style="width: 30px; float: left">
                            <i
                              style="font-size: 18px"
                              class="el-icon-shopping-cart-1"
                            ></i>
                          </div>
                          <div
                            style="
                              width: 300px;
                              float: left;
                              overflow: hidden;
                              color: #999999;
                              font-weight: bold;
                              font-size: 12px;
                            "
                          >
                            <span style="width: 100px">{{ _item.namec }} </span>
                            <span style="margin-left: 10px"
                              >({{ _item.namee }})</span
                            >
                          </div>
                          <div
                            style="float: left; margin-left: 10px"
                            class="handNumber"
                          >
                            <el-input
                              size="mini"
                              v-model.number="_item.num"
                              type="number"
                              minlength="1"
                              maxLength="9"
                              oninput="if(isNaN(value)) { value = null } if(value<=0) {value=null} if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                            >
                              <i
                                slot="suffix"
                                class="el-input__icon el-icon-plus"
                                @click="_item.num += 1"
                              ></i>
                              <i
                                slot="prefix"
                                class="el-input__icon el-icon-minus"
                                @click="
                                  (_item.num -= 1),
                                    _item.num <= 1 ? (_item.num = 1) : ''
                                "
                              ></i>
                            </el-input>
                          </div>
                          <div
                            class="goodsValue"
                            style="float: left; margin-left: 20px"
                          >
                            <span style="color: #999">货值(USD)</span>
                            <el-input
                              style="width: 150px; border: none"
                              size="mini"
                              v-model="_item.declaredValue"
                              placeholder="货值"
                            >
                            </el-input>
                          </div>
                          <div style="float: left; margin-left: 20px">
                            <el-button
                              class="el-icon-delete"
                              style="color: #f86670"
                              type="text"
                              size="mini"
                              @click="delBoxgood(index, _index)"
                              >删除</el-button
                            >
                          </div>
                        </div>
                      </el-collapse-item>
                    </el-collapse>
                    <!-- 折叠END -->
                    <div class="addStyle">
                      <el-button
                        plain
                        icon="el-icon-circle-plus-outline"
                        size="mini"
                        style="border-radius: 2px"
                        circle
                        @click="changegoods(index)"
                        >选择商品</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </el-form>
            <!-- demo 测试 END -->
          </div>

          <div
            style="width: 100%; float: left; padding: 30px"
            class="TB_center"
          >
            <el-button
              style="border-radius: 20px"
              type="primary"
              size="medium"
              @click="addItem('ruleform')"
              >+新增箱子</el-button
            >
          </div>
        </div>
      </div>
      <div class="wrap_R" :class="auto_fixed ? 'auto_fixed' : ''">
        <p
          style="
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #343434;
          "
        >
          费用计算
        </p>
        <div class="Item_Right animate__animated animate__bounceInRight">
          <p class="tit">运输费</p>
          <p
            class="coutText"
            v-for="(item, index) in FBATransmoney.goodsTypeFeeDTOS"
            :key="index"
          >
            <span class="littit">{{ item.goodsTypeName }}</span>
            <span class="fontString">{{ item.currency }}{{ item.amount }}</span>
            <span style="margin-left: 10px">({{ item.calDesc }})</span>
          </p>
          <p class="coutText">
            <span class="littit">小计</span>
            <span class="fontString"
              >{{ FBATransmoney.currency }}{{ FBATransmoney.amount }}</span
            >
          </p>
        </div>
        <div
          class="Item_Right animate__animated animate__bounceInRight"
          v-show="THFdata.checked"
        >
          <p class="tit">提货费</p>
          <p class="coutText">
            <span class="littit">发货地上门提货</span>
            <span class="fontString"
              >{{ THFdata.currency }}{{ THFdata.amount }}</span
            >
            <span
              class="littit"
              style="float: left; width: 100%"
              v-if="THFdata.maxKilometer > 0"
              >({{ THFdata.minKilometer }}--{{
                THFdata.maxKilometer
              }})公里</span
            >
          </p>
        </div>
        <div class="Item_Right">
          <p class="">
            <span class="littit">合计费用</span>
            <span
              v-for="(item, index) in this.newArray"
              :key="index"
              v-show="item.amount > 0"
            >
              <span
                ><span class="fontString" v-show="item.currency != ''">{{
                  item.currency
                }}</span>
                <span
                  class="fontString"
                  v-show="item.amount > 0"
                  style="margin-left: 5px; margin-right: 5px"
                  >{{ item.amount }}</span
                ></span
              >
              <span v-show="index == newArray.length - 1 ? false : true"
                >+</span
              >
            </span>
          </p>
          <p class="coutText">
            <span class="littit">折合人民币</span>
            <span class="fontString">CNY {{ calculatePrice }}</span>
          </p>
        </div>
        <div style="width: 100%; margin-top: 130px; float: left">
          <!-- <div style="width: 100%">
            <el-button style="width: 100%" @click="pathToback()"
              >上一步</el-button
            >
          </div> -->
          <div style="width: 100%; margin-top: 10px">
            <el-button
              style="width: 100%; background: #5643e6; color: #ffffff"
              @click="pathToNext('ruleform')"
              >下一步</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 地址弹窗 -->
    <div class="dialogCover" @click.self="closeMyDialog()" v-if="showMydialog">
      <div class="myDialog">
        <!-- header  -->
        <div style="display: flex; justify-content: space-between">
          <span style="font-weight: 600">提货地址</span>
          <i
            class="el-icon-close"
            @click="closeMyDialog()"
            style="cursor: pointer"
          ></i>
        </div>
        <!-- body   -->
        <div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              margin: 20px 0;
            "
          >
            <div>
              <el-input
                clearable
                @clear="getPeopletable()"
                v-model="nameOrPhone"
                @keyup.native="searchNameOrPhone"
                placeholder="请输入姓名或电话"
                size="medium"
                style="width: 250px"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                <el-button slot="append" type="primary">搜索</el-button>
              </el-input>
            </div>

            <el-button size="medium" plain type="primary" @click="showAdd(true)"
              >新增地址</el-button
            >
          </div>
          <!-- 新增或编辑 -->
          <div
            v-if="edit"
            style="
              background-color: #fff;
              border-radius: 20px;
              padding: 20px;
              box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.31);
            "
          >
            <div style="width: 85%; margin: 0 auto; max-width: 500px">
              <el-row
                :gutter="20"
                style="margin-bottom: 8px; margin-left: 1px; display: flex"
              >
                <div style="display: flex">
                  <div
                    class="grid-content"
                    style="margin-right: 35px; min-width: 50px"
                  >
                    <span style="line-height: 40px">联系人</span>
                  </div>

                  <div class="grid-content">
                    <el-input
                      v-model="submitForm.name"
                      placeholder="请输入联系人"
                    ></el-input>
                  </div>
                </div>
                <div style="display: flex">
                  <div
                    class="grid-content"
                    style="
                      margin-left: 10px;
                      margin-right: 10px;
                      min-width: 60px;
                    "
                  >
                    <span style="line-height: 40px">联系方式</span>
                  </div>

                  <div class="grid-content">
                    <el-input
                      v-model="submitForm.tel"
                      placeholder="请输入联系方式"
                    ></el-input>
                  </div>
                </div>
              </el-row>

              <el-row :gutter="20" style="margin-bottom: 8px">
                <el-col :span="4"
                  ><div class="grid-content">
                    <span style="line-height: 40px">联系地址</span>
                  </div></el-col
                >
                <el-col :span="18">
                  <div class="grid-content">
                    <el-cascader
                      :options="jackCitylist"
                      placeholder="请选择提货地址"
                      v-model="value"
                      clearable
                      @change="handleChange"
                      :props="props"
                    >
                    </el-cascader>
                  </div>
                </el-col>
              </el-row>

              <el-row :gutter="20" style="margin-bottom: 8px">
                <el-col :span="4"
                  ><div class="grid-content">
                    <div
                      style="line-height: 40px; width: 10px; height: 10px"
                    ></div></div
                ></el-col>
                <el-col :span="18"
                  ><div class="grid-content">
                    <el-input
                      v-model="submitForm.address"
                      type="textarea"
                      rows="2"
                      placeholder="请输入详细地址"
                    ></el-input></div
                ></el-col>
              </el-row>
              <el-row :gutter="20" style="margin-bottom: 8px">
                <el-col :span="4"
                  ><div class="grid-content">
                    <span style="line-height: 40px">标签</span>
                  </div></el-col
                >
                <el-col :span="18"
                  ><div class="grid-content">
                    <el-input
                      v-model="submitForm.tag"
                      placeholder="请输入标签"
                    ></el-input></div
                ></el-col>
              </el-row>

              <div style="width: 330px; margin: 0 auto; text-align: center">
                <div style="display: flex">
                  <el-checkbox
                    text-color="#FF4D01"
                    v-model="submitForm.isdefault"
                    style="margin-right: 10px"
                  ></el-checkbox>
                  <span style="display: block; margin-bottom: 8px">
                    设置为默认地址
                  </span>
                </div>
                <el-button
                  @click="addAddr"
                  style="
                    background: #FF4D01;
                    border: 1px solid #FF4D01;
                    border-radius: 5px;
                    color: #fff;
                  "
                  >{{ this.submitForm.id ? "修改" : "新增" }}</el-button
                >
                <el-button type="info" @click="showAdd(false)">关闭</el-button>
              </div>
            </div>
          </div>

          <el-table
            v-if="!edit"
            @row-click="rowClick"
            size="mini"
            height="300"
            tooltip-effect="dark"
            :data="tableData"
            max-height="200"
            highlight-current-row
            border
            ref="Table"
            style="width: 100%; overflow: hidden"
          >
            <el-table-column
              label="姓名"
              width="100"
              align="center"
              prop="name"
            >
            </el-table-column>
            <el-table-column label="电话" width="120" align="center" prop="tel">
            </el-table-column>
            <el-table-column
              label="联系地址"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.parvince }}
                {{ scope.row.city }}
                {{ scope.row.area }}
                {{ scope.row.address }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="160">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  @click.stop="setDefault(scope.row)"
                >
                  <span
                    :style="
                      scope.row.isdefault ? 'color:#FF4D01' : 'color:#9A9A9A'
                    "
                    >{{ scope.row.isdefault ? "默认" : "设为默认" }}</span
                  >
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="mini"
                  @click.stop="DeleteTitem(scope.$index, scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-alert
            v-if="!edit"
            style="margin-top: 20px"
            title="点击任意一行选择您的地址"
            type="info"
            center
            show-icon
          >
          </el-alert>
        </div>
      </div>
    </div>
    <!-- 地址弹窗 END -->
    <!-- 商品列表 -->
    <el-dialog title="商品列表" width="950px" :visible.sync="goodsTypeShow">
      <div class="typeHeader LR_center">
        <div>
          <el-input
            style="width: 314px"
            placeholder="请输入中文品名"
            v-model="Sgodname"
            class="input-with-select"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              type="primary"
              @click="getgoodsData(Sgodname)"
              >搜索</el-button
            >
          </el-input>
        </div>
        <div>
          <el-select
            clearable
            style="width: 100%"
            ref="changeFBAgoodtype"
            placeholder="请选择商品类型"
            v-model="ThatgoodsID"
            @change="getgoodsData(Sgodname)"
          >
            <el-option
              v-for="res in goodstypelist"
              :key="res.id"
              :label="res.cnName"
              :value="res.id"
            ></el-option>
          </el-select>
        </div>
        <div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            plain
            @click="addgoods()"
            >新增商品</el-button
          >
          <!-- <el-button type="primary" icon="el-icon-download" plain
            >导入商品</el-button
          > -->
        </div>
      </div>

      <div class="countTable" style="margin-top: 30px">
        <el-table
          ref="multipleTable"
          border
          :data="goodsLabel"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="中文名称" align="center" width="120">
            <template slot-scope="scope">{{ scope.row.namec }}</template>
          </el-table-column>
          <el-table-column
            prop="namee"
            label="英文品名"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column prop="materialc" align="center" label="中文材质">
          </el-table-column>
          <el-table-column prop="purposec" align="center" label="用途">
          </el-table-column>
          <el-table-column prop="hsCode" align="center" label="海关编码">
          </el-table-column>
          <el-table-column prop="goodstype" align="center" label="货物类型">
          </el-table-column>
          <el-table-column prop="goodstype" align="center" label="是否带电">
            <template slot-scope="scope">
              {{ scope.row.isHasBattery ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="goodstype"
            align="center"
            label="是否液体/粉末"
          >
            <template slot-scope="scope">
              {{ scope.row.isPowderLiquid ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="scope" v-if="scope.row.customerid">
              <el-button
                type="text"
                size="mini"
                @click="goodsEdit(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="text"
                style="color: red"
                @click="delGoodItem(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="qdBtn TB_center" style="width: 100%; margin-top: 50px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            layout="prev, pager, next"
            :total="goodslisttotal"
          ></el-pagination>
        </div>
        <div class="qdBtn TB_center" style="width: 100%; margin-top: 50px">
          <el-button type="primary" @click="setGoodspush()">确认选择</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 新增编辑商品弹窗 -->
    <el-dialog title="商品新增" :visible.sync="goodstextShow" width="850px">
      <div style="width: 100%">
        <el-form
          size="small"
          ref="addgoodform"
          :model="addgoodform"
          label-width="100px"
          class="LR_center"
        >
          <div style="width: 45%">
            <el-form-item
              style="width: 100%"
              label="中文品名"
              :rules="{
                required: true,
                message: '中文品名不能为空',
                trigger: 'blur',
              }"
            >
              <el-input
                placeholder="请输入中文品名"
                v-model="addgoodform.namec"
              ></el-input>
            </el-form-item>
            <el-form-item
              style="width: 100%"
              label="商品类型"
              :rules="{
                required: true,
                message: '商品类型不能为空',
                trigger: 'blur',
              }"
            >
              <el-select
                clearable
                style="width: 100%"
                ref="changeFBAgoodtype"
                placeholder="请选择商品类型"
                v-model="addgoodform.goodstypeid"
              >
                <el-option
                  v-for="res in goodstypelist"
                  :key="res.id"
                  :label="res.cnName"
                  :value="res.id"
                ></el-option>
              </el-select>
            </el-form-item>

            <!-- <el-select
              clearable
              style="width: 100%"
              ref="changeFBAgoodtype"
              placeholder="请选择商品类型"
              v-model="ThatgoodsID"
              @change="getgoodsData(Sgodname)">
                   <el-option v-for="res in goodstypelist" :key="res.id" :label="res.cnName" :value="res.id"></el-option>
          </el-select> -->

            <el-form-item style="width: 100%" label="品牌">
              <el-input
                placeholder="请输入商品品牌"
                v-model="addgoodform.brand"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="海关编码">
              <el-input
                placeholder="请输入海关编码"
                v-model="addgoodform.hsCode"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="中文材质">
              <el-input
                placeholder="请输入中文材质"
                v-model="addgoodform.materialc"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="中文用途">
              <el-input
                style="width: 100%"
                placeholder="请输入中文用途"
                v-model="addgoodform.purposec"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="是否带电">
              <el-select
                style="width: 100%"
                v-model="addgoodform.isHasBattery"
                placeholder="请选择"
              >
                <el-option label="是" :value="true"> </el-option>
                <el-option label="否" :value="false"> </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div style="width: 45%">
            <el-form-item
              style="width: 100%"
              label="英文品名"
              :rules="{
                required: true,
                message: '英文品名不能为空',
                trigger: 'blur',
              }"
            >
              <el-input
                style="width: 100%"
                placeholder="请输入英文品名"
                v-model="addgoodform.namee"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="SKU">
              <el-input
                placeholder="请输入商品SKU"
                v-model="addgoodform.sku"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="货值(USD)">
              <el-input
                placeholder="请输入商品货值"
                type="number"
                v-model.number="addgoodform.declaredValue"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="英文材质">
              <el-input
                placeholder="请输入英文材质"
                v-model="addgoodform.materiale"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="英文用途">
              <el-input
                placeholder="请输入英文用途"
                v-model="addgoodform.purposee"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%" label="是否液体/粉末">
              <el-select
                style="width: 100%"
                v-model="addgoodform.isPowderLiquid"
                placeholder="请选择"
              >
                <el-option label="是" :value="true"> </el-option>
                <el-option label="否" :value="false"> </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div
          style="width: 100%; padding: 30px; box-sizing: border-box"
          class="TB_center"
        >
          <el-button type="primary" @click="addgoodtext('addgoodform')">{{
            GoodsCategory ? "确认新增" : "确认修改"
          }}</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增编辑商品弹窗END -->

    <!-- Excel上传 -->
    <el-dialog title="文件上传" :visible.sync="excelVisible" width="40%" center>
      <el-upload
        style="text-align: center"
        :show-file-list="false"
        :on-error="handleError"
        :on-success="handleSuccess"
        :before-upload="handleBeforeUpload"
        :http-request="uploadSectionFile"
        class="upload-demo"
        drag
        action=""
        multiple
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <div class="helper">如需提供帮助，请致电400-992-1818</div>
      <span slot="footer" class="dialog-footer">
        <el-button
          style="margin-right: 20px"
          size="mini"
          @click="excelVisible = false"
          >取 消</el-button
        >
        <el-link target="_blank">
          <el-button size="mini" type="success" @click="Getdown()"
            >下载模板</el-button
          >
        </el-link>
      </span>
      <template>
        <el-table
          v-show="errorLabel.length > 0"
          :data="errorLabel"
          size="mini"
          border
          style="width: 100%"
        >
          <el-table-column align="center" width="50" type="index" label="序号">
          </el-table-column>
          <el-table-column
            align="center"
            width="80"
            prop="order"
            label="错误行"
          >
          </el-table-column>
          <el-table-column label="错误描述">
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.desc }}</span>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-dialog>

    <!-- 示例图 -->
    <el-dialog title="示例图" :visible.sync="imagesType" width="600px" center>
      <img
        v-show="imageNum == 1"
        src="../../../static/images/boxdemo.png"
        alt="FBA纸箱编号"
      />
      <img
        v-show="imageNum == 2"
        src="../../../static/images/ponum.png"
        alt="发/补货编号"
      />
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
export default {
  data() {
    return {
      billType: null,
      imageNum: 1,
      imagesType: false,
      PathCBM: 0,
      errorLabel: [],
      upUrl: "",
      excelVisible: false,
      transportTypeCode: null,
      goodstextShow: false,
      goodsTypeShow: false,
      GoodsCategory: true, //true是新增 false是修改
      Sgodname: "",
      // jack
      getLIstType: "",
      props: {
        value: "namec",
        label: "namec",
      },
      value: [],
      countLIst_T: {
        address: "",
        area: "",
        city: "",
        customerid: "",
        id: "",
        isdefault: null,
        name: "",
        parvince: "",
        tag: "",
        tel: "",
      },
      showMydialog: false,
      jackCitylist: [],
      submitForm: {
        address: "",
        area: "",
        city: "",
        customerid: 0,
        id: 0,
        isdefault: false,
        name: "",
        parvince: "",
        tag: "",
        tel: "",
      },
      edit: false,
      nameOrPhone: "",
      tableData: [],
      tempTableData: [],
      goodslisttotal: 0,
      // jack end
      goodstypelist: [],
      moreNotOjb: {
        // Nottypeid: [
          // { required: true, message: "货物类型不能为空" },
          // {
          //   validator: (rule, value, callback) => {   校验正整数
          //     if (value.length > 15 || value.length < 1) {
          //       callback(new Error("长度只能为1-15个字符"));
          //     } else {
          //       var reg = /^[1-9]\d*$/;
          //       if (!reg.test(value)) {
          //         callback(new Error("件数不能小于等于0"));
          //       } else {
          //         callback();
          //       }
          //     }
          //   },
          //   trigger: "change",
          // },
        // ],
        // Notponum: [
        //   { required: true, message: "货件追踪号不能为空" },
        //   {
        //     validator: (rule, value, callback) => {
        //       if (value.length > 8 || value.length < 8) {
        //         callback(new Error("长度只能为8个字符"));
        //       } else {
        //         var reg = /^[a-zA-Z0-9]+$/;
        //         if (!reg.test(value)) {
        //           callback(new Error("只能为数字和字母"));
        //         } else {
        //           callback();
        //         }
        //       }
        //     },
        //     trigger: "change",
        //   },
        // ],
        // Notgoodsnum: [{ required: true, message: "商户号不能为空" }],
        // Notboxnum: [
        //   { required: true, message: "箱号不能为空" },
        //   {
        //     validator: (rule, value, callback) => {
        //       var index = value.toLowerCase().indexOf("fba");
        //       if (this.billType) {
        //         if (index == 0) {
        //           if (value.length < 19 || value.length > 19) {
        //             callback(new Error("长度必须为19位字符"));
        //           } else {
        //             callback();
        //           }
        //         } else {
        //           callback(new Error("必须以FBA字符开头"));
        //         }
        //       } else {
        //         callback();
        //       }
        //     },
        //     trigger: "change",
        //   },
        // ],
        // goodsNotname: [{ required: true, message: "品名不能为空" }],
        // Notweight: [
        //   { required: true, message: "重量不能为空" },
        //   {
        //     validator: (rule, value, callback) => {
        //       if (value.length > 15 || value.length < 1) {
        //         callback(new Error("长度只能为1-15个字符"));
        //       } else {
        //         var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
        //         if (value <= 0) {
        //           callback(new Error("重量只能大于零且保留最多两位小数"));
        //         }
        //         if (!reg.test(value)) {
        //           callback(new Error("重量只能大于零且保留最多两位小数"));
        //         } else {
        //           callback();
        //         }
        //       }
        //     },
        //     trigger: "change",
        //   },
        // ],
        // Notlength: [
        //   { required: true, message: "长度不能为空" },
        //   {
        //     validator: (rule, value, callback) => {
        //       if (value.length > 15 || value.length < 1) {
        //         callback(new Error("长度只能为1-15个字符"));
        //       } else {
        //         var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
        //         if (value <= 0) {
        //           callback(new Error("长度只能大于零且保留最多两位小数"));
        //         }
        //         if (!reg.test(value)) {
        //           callback(new Error("长度只能大于零且保留最多两位小数"));
        //         } else {
        //           callback();
        //         }
        //       }
        //     },
        //     trigger: "change",
        //   },
        // ],
        // Notwidth: [
        //   { required: true, message: "宽度不能为空" },
        //   {
        //     validator: (rule, value, callback) => {
        //       if (value.length > 15 || value.length < 1) {
        //         callback(new Error("长度只能为1-15个字符"));
        //       } else {
        //         var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
        //         if (!reg.test(value)) {
        //           callback(new Error("宽度只能大于零且保留最多两位小数"));
        //         } else {
        //           callback();
        //         }
        //       }
        //     },
        //     trigger: "change",
        //   },
        // ],
        // Notheight: [
        //   { required: true, message: "高度不能为空" },
        //   {
        //     validator: (rule, value, callback) => {
        //       if (value.length > 15 || value.length < 1) {
        //         callback(new Error("长度只能为1-15个字符"));
        //       } else {
        //         var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
        //         if (!reg.test(value)) {
        //           callback(new Error("高度只能大于零且保留最多两位小数"));
        //         } else {
        //           callback();
        //         }
        //       }
        //     },
        //     trigger: "change",
        //   },
        // ],
      },

      SonshowType: true,
      defaultParams: {
        label: "namec",
        value: "namec",
        children: "children",
      },
      shouaddressid: [],
      WaicountLIst: [],
      showType: false,
      addType: false,
      Timeshow: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      auto_fixed: false,
      cbm: null,
      tableData: [],
      Citydata: null,
      fromFABck: sessionStorage.getItem("fromFABck")
        ? JSON.parse(sessionStorage.getItem("fromFABck"))
        : {},
      toFABck: sessionStorage.getItem("toFABck")
        ? JSON.parse(sessionStorage.getItem("toFABck"))
        : {},
      PStablelist: [],
      searchPSname: "",
      FBATransmoney: {
        //运输费
        feeType: "Q",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
        goodsTypeFeeDTOS: [],
      },

      newTihuoarr: "", //需展示的提货地址
      todoorTime: null,
      THFdata: {
        //提货费
        checked: false,
        feeCode: "THF",
        price: "",
        currency: "",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: "",
        piece: 1,
        minKilometer: "",
        maxKilometer: "",
      },
      pageNum: 1,
      ruleform: {
        formLIst: [
          {
            goodstypeid: "", //货物类型
            typeName: "", //货物类型名字
            weight: "", //重量
            length: "", //长
            width: "", //宽
            height: "", //高
            shopName: "", //商户号
            poTrackingNo: "", //po追踪号
            fbxBoxNo: "", //箱号
            cbm: 0,
            goodsDTOList: [],
          },
        ],
      },
      contactype2: "",
      dialogFormVisible: false,
      totalMolist: [],
      clickPsitem: {}, //当前点击收货地址item
      addgoodform: {
        id: "",
        brand: "",
        customerid: "",
        declaredValue: "",
        goodstypeid: "",
        hsCode: "",
        materialc: "",
        materiale: "",
        namec: "",
        namee: "",
        purposec: "",
        purposee: "",
        sku: "",
        isHasBattery: false,
        isPowderLiquid: false,
      },
      setLIstdata: [],
      thatGoodslist: [],
      goodsLabel: [],
      ThatgoodsID: "",
      BoxWrapindex: null,
      activeLIst: [],
      thatindexgslist: [],
    };
  },
  watch: {},
  computed: {
    activeName() {
      let activeName = [];
      this.ruleform.formLIst.forEach((item, index) => {
        activeName.push(index);
      });
      this.activeLIst = activeName;
      return activeName;
    },
    calculatePrice() {
      //计算总费用
      let Totalmoney = 0; //总费用
      let FBATransmoney = 0; //运输费
      let THFmoney = 0; //提货费
      FBATransmoney = this.FBATransmoney.cnyamount
        ? +this.FBATransmoney.cnyamount
        : 0;
      if (this.THFdata.checked) {
        //如果有提货费
        THFmoney = this.THFdata.cnyamount ? +this.THFdata.cnyamount : 0;
      }
      Totalmoney = FBATransmoney + THFmoney;
      return Totalmoney.toFixed(2);
    },
    newArray() {
      //监听 币种
      let totalFeiyong = []; //当前勾选
      totalFeiyong.push(JSON.parse(JSON.stringify(this.FBATransmoney))); //海运费币种
      if (this.THFdata.checked) {
        totalFeiyong.push(JSON.parse(JSON.stringify(this.THFdata))); //提货费费币种
      }
      let newArray = totalFeiyong.reduce((total, cur, index) => {
        let hasValue = total.findIndex((current) => {
          return current.currency === cur.currency;
        });
        hasValue === -1 && total.push(cur);
        hasValue !== -1 &&
          (total[hasValue].amount = this.accAdd(
            total[hasValue].amount,
            cur.amount
          ));
        return total;
      }, []);
      return newArray;
    },
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getgoodsData();
    },
    Getdown() {
      //下载模板
      this.axios
        .get(`/busFbx/downFBXBoxGoodsTemplate`, {
          responseType: "arraybuffer" /* 一定要加这个 不然文件内容显示不了 */,
        })
        .then((res) => {
          console.log(res);
          if (res.status) {
            let a = document.createElement("a");
            let blob = new Blob([res.data]);
            let objectUrl = URL.createObjectURL(blob);
            a.setAttribute("href", objectUrl);
            a.setAttribute("download", "商品模板.xls");
            a.click();
            URL.revokeObjectURL(objectUrl); // 释放内存
          } else {
          }
        })
        .catch((res) => {});
    },
    clickme(item) {
      console.log(item);
    },
    handleOPen(index) {
      console.log(index);
    },
    goodsEdit(index, item) {
      console.log(item);
      this.GoodsCategory = false;
      this.goodstextShow = true;
      this.addgoodform.customerid = this.sessionGetUserInfo().customerid; //客户id,
      this.addgoodform.brand = item.brand;
      this.addgoodform.declaredValue = item.declaredValue;
      this.addgoodform.goodstypeid = this.ThatgoodsID;
      this.addgoodform.hsCode = item.hsCode;
      this.addgoodform.materialc = item.materialc;
      this.addgoodform.materiale = item.materiale;
      this.addgoodform.namec = item.namec;
      this.addgoodform.namee = item.namee;
      this.addgoodform.purposec = item.purposec;
      this.addgoodform.purposee = item.purposee;
      this.addgoodform.sku = item.sku;
      this.addgoodform.id = item.id;
      this.addgoodform.isHasBattery = item.isHasBattery;
      this.addgoodform.isPowderLiquid = item.isPowderLiquid;
      this.addgoodform.goodstypeid = item.goodstypeid;
    },
    addgoodtext(formName) {
      if (this.addgoodform.namec == "") return this.$message("请输入中文品名");
      if (this.addgoodform.namee == "") return this.$message("请输入英文品名");
      if (this.addgoodform.goodstypeid == "")
        return this.$message("请选择商品类型");
      // if (this.addgoodform.declaredValue == "") return this.$message("请输入货值");
      // if(+this.addgoodform.declaredValue<=0) return this.$message("货值必须大于0");
      // if (this.addgoodform.declaredValue <= 0) return this.$message("货值不能小于0");
      let params = {
        customerid: this.sessionGetUserInfo()
          .customerid, //客户id,
        brand: this.addgoodform.brand,
        declaredValue: this.addgoodform.declaredValue,
        goodstypeid: this.addgoodform.goodstypeid,
        hsCode: this.addgoodform.hsCode,
        materialc: this.addgoodform.materialc,
        materiale: this.addgoodform.materiale,
        namec: this.addgoodform.namec,
        namee: this.addgoodform.namee,
        purposec: this.addgoodform.purposec,
        purposee: this.addgoodform.purposee,
        sku: this.addgoodform.sku,
        id: this.addgoodform.id,
        isHasBattery: this.addgoodform.isHasBattery,
        isPowderLiquid: this.addgoodform.isPowderLiquid,
      };
      this.axios
        .post(`/busFbx/addOrUpdateFbxCustomerGoodsCategory`, params)
        .then((res) => {
          if (res.data.code == "200") {
            this.goodstextShow = false;
            this.getgoodsData();
            this.$message({
              message: "成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.message,
              type: "info",
            });
          }
        })
        .catch((res) => {});
    },
    delGoodItem(index, item) {
      this.$confirm("确定删除此商品信息吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: item.id,
          };
          this.axios
            .post(
              `/busFbx/deleteFbxCustomerGoodsCategory`,
              qs.stringify(params)
            )
            .then((res) => {
              if (res.data.code == "200") {
                this.goodstextShow = false;
                this.getgoodsData();
              } else {
              }
            })
            .catch((res) => {});
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    changeGStype(id, index) {
      //切换货物类型
      this.getFBATrans(); //获取运输费
      this.ruleform.formLIst[index].goodsDTOList = [];
      let typeName = "";
      this.goodstypelist.forEach((item) => {
        if (id == item.id) {
          typeName = item.cnName;
        }
      });
      this.ruleform.formLIst[index].typeName = typeName;
    },
    addgoods() {
      //新增商品信息
      this.goodstextShow = true;
      this.GoodsCategory = true;
      this.addgoodform.id = "";
      this.addgoodform.brand = "";
      this.addgoodform.customerid = "";
      this.addgoodform.declaredValue = "";
      this.addgoodform.goodstypeid = "";
      this.addgoodform.hsCode = "";
      this.addgoodform.materialc = "";
      this.addgoodform.materiale = "";
      this.addgoodform.namec = "";
      this.addgoodform.namee = "";
      this.addgoodform.purposec = "";
      this.addgoodform.purposee = "";
      this.addgoodform.sku = "";
      this.addgoodform.isHasBattery = false;
      this.addgoodform.isPowderLiquid = false;
    },
    changegoods(index) {
      this.Sgodname = "";
      // if (!this.ruleform.formLIst[index].goodstypeid) return this.$message("请先选择商品类型");
      // this.ThatgoodsID = this.ruleform.formLIst[index].goodstypeid;

      this.thatindexgslist = [];
      if (this.ruleform.formLIst[index].goodsDTOList.length > 0) {
        //if 当前箱子内有货物
        this.ruleform.formLIst[index].goodsDTOList.forEach((item) => {
          this.thatindexgslist.push(item);
        });
      } else {
        this.thatindexgslist = [];
      }
      console.log(this.thatindexgslist);
      this.BoxWrapindex = index;
      this.getgoodsData();
      this.goodsTypeShow = true;
    },
    handleSelectionChange(val) {
      this.thatGoodslist = val;
      console.log(val);
    },
    setGoodspush() {
      if (this.thatGoodslist.length == 0) return this.$message("请选择商品");
      let newarray = this.thatindexgslist.concat(this.thatGoodslist);
      let idlist = [];
      newarray.forEach((item) => {
        idlist.push(item.goodstypeid);
      });
      idlist = [...new Set(idlist)];
      if (idlist.length > 1)
        return this.$message("单箱内只能放入同一种货物类型");

      let arr1 = JSON.parse(
        JSON.stringify(this.ruleform.formLIst[this.BoxWrapindex].goodsDTOList)
      );
      this.thatGoodslist.forEach((item) => {
        arr1.push(item);
      });

      let newArr = [];
      arr1.forEach((el) => {
        const result = newArr.findIndex((ol) => {
          return el.id === ol.id;
        });
        if (result !== -1) {
          newArr[result].num = newArr[result].num + el.num;
        } else {
          newArr.push(el);
        }
      });

      if (this.toFABck.countryCode == "SA") {
        if (newArr.length > 3)
          return this.$message("单箱子内商品类型不能超过3件");
      }

      this.goodsTypeShow = false;
      this.ruleform.formLIst[this.BoxWrapindex].goodsDTOList = newArr;
      this.ruleform.formLIst[this.BoxWrapindex].goodstypeid =
        newArr[0].goodstypeid;
      this.ruleform.formLIst[this.BoxWrapindex].typeName = newArr[0].goodstype;
      this.getFBATrans();
    },
    getgoodsData(name) {
      //获取商品列表
      let params = {
        customerid: this.sessionGetUserInfo()
          .customerid, //客户id,
        goodstypeid: this.ThatgoodsID,
        name: name,
        towarehouseid: this.toFABck.id,
        pageNum: this.pageNum,
        pageSize: 10,
      };
      this.axios
        .post(`/busFbx/getFbxCustomerGoodsCategoryList`, params)
        .then((res) => {
          if (res.data.code == "200") {
            console.log(res);
            res.data.data.list.forEach((item) => {
              this.$set(item, "num", 1);
            });
            this.goodsLabel = res.data.data.list;
            this.goodslisttotal = res.data.data.total;
          } else {
          }
        })
        .catch((res) => {});
    },
    //-----------
    getGoodstypelist() {
      //商品类型
      let params = {
        warehouseId: this.toFABck.id,
      };
      this.axios
        .get(`/filedata/findFBAGoodTypeList?warehouseId=${this.toFABck.id}`)
        .then((res) => {
          if (res.data.code == "200") {
            this.goodstypelist = res.data.datas;
          } else {
          }
        })
        .catch((res) => {});
    },
    accAdd(arg1, arg2) {
      //加法精度
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    isSize(val) {
      val = val.replace(/[^0-9]/gi, "");
      return val;
    },
    isnumber(val) {
      val = val.replace(/\d+(\.\d{0,2})?/, "");
      return val;
    },

    changeTi() {
      this.THFdata.checked != this.THFdata.checked;
      if (this.THFdata.checked) {
        this.getTimoney();
      }
    },
    pathToNext(formName) {
      let PathCBM = 0;
      let flag = true;
      let fromArr = this.ruleform.formLIst;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let File = true;
          try {
            fromArr.forEach((item, index) => {
              item.cbm = (item.length * item.width * item.height) / 1000000;
              PathCBM += parseFloat(+item.cbm);

              if (item.goodsDTOList.length == 0)
                throw this.$message({
                  message: `请添加${index + 1}号箱子内商品信息`,
                });
              item.goodsDTOList.forEach((_item) => {
                if (_item.num == 0 || _item.num == null) {
                  throw this.$message({ message: `添加的商品数量不能为0` });
                }
                if (!_item.declaredValue)
                  throw this.$message({ message: `请添加商品货值` });
                if (_item.declaredValue <= 0)
                  throw this.$message({ message: `货值必须大于0` });
              });
            });
            const standardNameList = fromArr.map(
              (standard) => standard.fbxBoxNo
            );
            if (new Set(standardNameList).size != standardNameList.length) {
              throw this.$message({ message: `箱号存在重复请检查` });
            }
          } catch (err) {
            File = false;
          }
          if (File) {
            if (this.billType && this.toFABck.countryCode == "SA") {
              let newArray = JSON.parse(JSON.stringify(this.ruleform.formLIst));
              newArray.forEach((item, index) => {
                item.fbxBoxNo = item.fbxBoxNo.substr(0, 12);
              });
              for (var i = 0; i < newArray.length - 1; i++) {
                for (var j = i + 1; j < newArray.length; j++) {
                  if (newArray[i].fbxBoxNo === newArray[j].fbxBoxNo) {
                    if (newArray[i].shopName !== newArray[j].shopName)
                      return this.$message({
                        message: this.$createElement("p", null, [
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `第`
                          ),
                          this.$createElement(
                            "i",
                            { style: "color: #E6A23C" },
                            `${i + 1}`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `箱`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `和`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `第`
                          ),
                          this.$createElement(
                            "i",
                            { style: "color: #E6A23C" },
                            `${j + 1}`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `箱PO号相同，请填写相同的`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #F56C6C" },
                            "<商铺号>"
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #F56C6C" },
                            "<货件追踪号>"
                          ),
                        ]),
                      });
                    if (newArray[i].poTrackingNo !== newArray[j].poTrackingNo)
                      return this.$message({
                        message: this.$createElement("p", null, [
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `第`
                          ),
                          this.$createElement(
                            "i",
                            { style: "color: #E6A23C" },
                            `${i + 1}`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `箱`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `和`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `第`
                          ),
                          this.$createElement(
                            "i",
                            { style: "color: #E6A23C" },
                            `${j + 1}`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #909399" },
                            `箱PO号相同，请填写相同的`
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #F56C6C" },
                            "<商铺号>"
                          ),
                          this.$createElement(
                            "span",
                            { style: "color: #F56C6C" },
                            "<货件追踪号>"
                          ),
                        ]),
                      });
                  }
                }
              }
            }

            sessionStorage.setItem(
              "boxLIst",
              JSON.stringify(this.ruleform.formLIst)
            ); //商品信息
            sessionStorage.setItem("THFdata", JSON.stringify(this.THFdata)); //提货费
            sessionStorage.setItem(
              "FBATransmoney",
              JSON.stringify(this.FBATransmoney)
            ); //运输费
            if (this.THFdata.checked) {
              //如果勾选了提货
              let params = {
                countryOrProvince: this.countLIst_T.parvince,
                fromWarehouseId: this.fromFABck.id,
              };
              if (!this.countLIst_T.parvince)
                return this.$message("请选择上门提货地址");
              if (this.todoorTime == null)
                return this.$message("请选择上门提货时间");
              sessionStorage.setItem("todoorTime", this.todoorTime); //提货时间
              this.axios
                .post(
                  `/busLcljobsBefore/validateDeliveryAddress`,
                  qs.stringify(params)
                )
                .then((res) => {
                  if (res.data.code == 200) {
                    this.$router.push({
                      name: "Fbaservice",
                      query: { PathCBM: PathCBM },
                    });
                    return;
                  } else {
                    flag = false;
                    return this.$message({
                      message: `提货地址与起运地仓库非同一国家，请重新选择`,
                    });
                  }
                })
                .catch((res) => {});
            } else {
              sessionStorage.removeItem("todoorTime");
              sessionStorage.removeItem("countLIst_T");
              this.$router.push({
                name: "Fbaservice",
                query: { PathCBM: PathCBM },
              });
            }
          }
        } else {
          flag = false;
          return false;
        }
      });
    },
    // pathToback() {
    //   this.$router.go(-1);
    // },
    getFBATrans() {
      //获取运输费
      this.loadin = true;
      let that = this;
      let boxDTOS = [];
      this.ruleform.formLIst.forEach((item, index) => {
        let goodItem = {
          goodsTypeId: 0,
          height: 0,
          length: 0,
          weight: 0,
          width: 0,
        };
        goodItem.goodsTypeId = item.goodstypeid;
        goodItem.height = item.height;
        goodItem.length = item.length;
        goodItem.width = item.width;
        goodItem.weight = item.weight;
        boxDTOS.push(goodItem);
      });

      let params = {
        feeCode: "QBHYF",
        pollandId: JSON.parse(sessionStorage.getItem("fromFABck")).id, //起运地id,
        podlandId: JSON.parse(sessionStorage.getItem("toFABck")).id, //目的地仓库
        customerId: this.sessionGetUserInfo()
          .customerid, //客户id
        boxDTOS: boxDTOS,
        transportTypeCode: JSON.parse(
          sessionStorage.getItem("transportTypeCode")
        ),
      };
      this.axios
        .post(`/FBAfee/getFBATransportFee`, params)
        .then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            that.FBATransmoney.price = res.data.data.price;
            that.FBATransmoney.currency = res.data.data.currency;
            that.FBATransmoney.cnyprice = res.data.data.price;
            that.FBATransmoney.piece = 1;
            that.FBATransmoney.amount = res.data.data.amount;
            that.FBATransmoney.cnyamount = res.data.data.cnyamount;
            that.FBATransmoney.goodsTypeFeeDTOS =
              res.data.data.goodsTypeFeeDTOS;
          } else {
            that.FBATransmoney.cnyamount = 0;
            that.FBATransmoney.amount = 0;
            that.FBATransmoney.price = "";
            that.FBATransmoney.currency = "";
            that.FBATransmoney.cnyprice = "";
            that.FBATransmoney.goodsTypeFeeDTOS = [];
          }
        })
        .catch((res) => {});
    },
    // 设为默认
    setDefault(item) {
      if (item.isdefault) {
        return this.$message.info("已经是默认地址");
      }
      this.axios
        .post(`/customer/updateAddressDefault?addressId=${item.id}`, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.getPeopletable();
            this.$message.success("设置成功！");
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {});
    },
    getTimoney() {
      //获取提货费
      let that = this;
      let weight = 0,
        cbm = 0;
      this.ruleform.formLIst.forEach((item, index) => {
        item.cbm = (item.length * item.width * item.height) / 1000000;
        weight += parseFloat(+item.weight);
        cbm += parseFloat(+item.cbm);
      });
      let params = {};

      params = {
        province: this.countLIst_T.parvince, //省 name
        city: this.countLIst_T.city, //市 name
        area: this.countLIst_T.area, //区 name
        customerId: this.sessionGetUserInfo()
          .customerid, //客户id
        feeCode: "THF",
        inWarehouseId: JSON.parse(sessionStorage.getItem("fromFABck")).id,
        weight: weight,
        cbm: cbm,
      };
      this.axios
        .post(`/FBAfee/getFBAPickUpFee`, params)
        .then((res) => {
          console.log(res.data.data);
          if (res.data.code == "200") {
            if (res.data.data) {
              that.THFdata.price = res.data.data.price; //价格
              that.THFdata.currency = res.data.data.currency; //币种
              that.THFdata.cnyprice = res.data.data.cnyprice; //--隐藏单价
              that.THFdata.cnycurrency = res.data.data.cnycurrency; //”CNY”--换算币种
              that.THFdata.cnyamount = res.data.data.cnyprice; //”CNY”--换算币种
              that.THFdata.amount = res.data.data.price;
              that.THFdata.maxKilometer = res.data.data.maxKilometer;
              that.THFdata.minKilometer = res.data.data.minKilometer;
            } else {
              that.THFdata.price = null;
              that.THFdata.currency = "";
              that.THFdata.cnyprice = null;
              that.THFdata.amount = null;
            }
          } else {
          }
        })
        .catch((res) => {});
    },
    clone(box) {
      this.$refs["ruleform"].validate((valid) => {
        let boxItem = JSON.parse(JSON.stringify(box));
        boxItem.fbxBoxNo = "";
        if (valid) {
          this.ruleform.formLIst.push(JSON.parse(JSON.stringify(boxItem)));
          this.getTimoney(); //重新计算提货费
          this.getFBATrans(); //重新计算运输费
        } else {
          this.$message({
            type: "info",
            message: "请填充完整箱子信息",
          });
          return false;
        }
      });
    },
    DeleteTitem(index, row) {
      let that = this;
      this.$confirm("确定删除该联系人吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.axios
            .post(`/customer/delAddress/${row.id}`)
            .then((res) => {
              if (res.data.code == "200") {
                that.$message({
                  message: res.data.message,
                  type: "success",
                });
                this.getPeopletable();
              } else {
                that.$message({
                  message: res.data.message,
                  type: "info",
                });
              }
            })
            .catch((res) => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    addItem(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let File = true;
          try {
            this.ruleform.formLIst.forEach((item, index) => {
              console.log(item.goodsDTOList);
              if (item.goodsDTOList.length == 0)
                throw this.$message({
                  message: `请添加${index + 1}号箱子内商品信息`,
                });
              item.goodsDTOList.forEach((_item) => {
                if (_item.num == 0 || _item.num == null) {
                  throw this.$message({ message: `添加的商品数量不能为0` });
                }
                if (!_item.declaredValue)
                  throw this.$message({ message: `请添加商品货值` });
              });
            });
          } catch (err) {
            File = false;
          }
          if (File) {
            this.activeName = [];
            this.ruleform.formLIst.push({
              goodstypeid: "", //货物类型
              typeName: "",
              weight: "", //重量
              length: "", //长
              width: "", //宽
              height: "", //高
              shopName: "", //商户号
              poTrackingNo: "", //po追踪号
              fbxBoxNo: "", //箱号
              cbm: 0,
              goodsDTOList: [],
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    delBoxgood(index, _index) {
      //删除箱子内某个商品
      this.ruleform.formLIst[index].goodsDTOList.splice(_index, 1);
    },
    handleDelete(index) {
      //删除箱子信息
      this.$confirm("确定删除该箱子信息吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.ruleform.formLIst.splice(index, 1);
          this.getFBATrans();
          this.getTimoney();
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getProvinces() {
      //获取国外地址
      let customerid = this.sessionGetUserInfo().customerid;
      this.axios
        .post(`/filedata/findThirdLevelAddress`)
        .then((res) => {
          this.WaicountLIst = res.data.datas;
        })
        .catch((res) => {});
    },
    getPeopletable() {
      //获取提货联系人
      let that = this;
      let customerId = this.sessionGetUserInfo().customerid;
      this.axios
        .get(`/customer/addressListForFBADelivery/${customerId}`)
        .then((res) => {
          if (res.data.code == "200") {
            this.tableData = res.data.datas;
            this.tempTableData = res.data.datas;
          } else {
          }
        })
        .catch((res) => {});
    },
    onScroll() {
      // 计算滚动的距离
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 计算A区的高度
      let header_height = null;
      if (document.getElementsByClassName("wrap_R")[0]) {
        header_height =
          document.getElementsByClassName("wrap_R")[0].offsetHeight;
      }
      if (scrolled >= 200) {
        this.auto_fixed = true;
      } else {
        this.auto_fixed = false;
      }
    },

    // -------------------------弹窗地址-----------------------
    // jack methods start
    // 获取省市区列表
    // 关闭弹窗
    closeMyDialog() {
      if (this.edit) {
        this.$confirm("当前为编辑状态,是否关闭?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.showMydialog = false;
            this.showAdd(false);
          })
          .catch((res) => {});
      } else {
        this.showMydialog = false;
      }
    },
    // 显示弹窗
    changeCheic(type) {
      this.getPeopletable(); //获取提货联系人
      this.showMydialog = true;
    },
    // 校验
    very() {
      if (!this.submitForm.name) {
        this.$message.info("联系人不能为空！");
        return false;
      }
      if (!this.submitForm.tel) {
        this.$message.info("手机号不能为空！");
        return false;
      }
      // 城市
      if (!this.submitForm.city) {
        this.$message.info("联系地址不能为空！");
        return false;
      }
      // 区
      if (!this.submitForm.area) {
        this.$message.info("联系地址不能为空！");
        return false;
      }
      if (!this.submitForm.address) {
        this.$message.info("详细地址不能为空！");
        return false;
      }
      if (this.submitForm.tag) {
        if (this.submitForm.tag.length > 5) {
          this.$message.info("标签长度不能超过五个字符");
          return false;
        }
      }

      return true;
    },
    // 显示新增
    showAdd(type) {
      if (type) {
        this.edit = true;
      } else {
        this.edit = false;
      }

      this.value = [];
      for (let key in this.submitForm) {
        this.submitForm[key] = "";
      }
    },
    handleChange(value) {
      this.submitForm.parvince = value[0];
      this.submitForm.city = value[1];
      this.submitForm.area = value[2];
    },
    // 模糊搜索
    searchNameOrPhone() {
      if (!this.nameOrPhone) {
        return this.getPeopletable();
      }
      let temp = [];
      this.tempTableData.forEach((item, index) => {
        if (
          item.name.indexOf(this.nameOrPhone) != -1 ||
          item.tel.indexOf(this.nameOrPhone) != -1
        ) {
          temp.push(item);
        }
      });
      this.tableData = temp;
    },
    addAddr(id) {
      if (!this.very()) {
        return;
      }
      if (!this.submitForm.id) {
        delete this.submitForm.id;
      }
      let user = this.sessionGetUserInfo();
      // 新增
      this.submitForm.customerid = user.customerid;
      let path = "addOrUpdateDelivery";

      this.axios
        .post(`/customer/${path}`, this.submitForm, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.edit = false;
            this.value = [];
            this.getPeopletable();
            for (let key in this.submitForm) {
              this.submitForm[key] = "";
            }
          } else {
            this.$message.info(res.data.message);
          }
        })
        .catch((res) => {});
    },
    // 点击行
    rowClick(r) {
      this.countLIst_T = r;
      sessionStorage.setItem("countLIst_T", JSON.stringify(this.countLIst_T));
      this.showMydialog = false;
      this.getTimoney(); //重新计算提货费
    },
    //  edit
    getPopList() {
      // 获取省市区列表
      let user = this.sessionGetUserInfo();
      this.axios
        .post(`/filedata/findDAndILevelAddress`, {}, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.jackCitylist = res.data.datas;
          } else {
            this.$message.info("服务器繁忙");
          }
        })
        .catch((res) => {
          this.$message.info("服务器繁忙");
        });
    },
    handleEdit(index, item) {
      this.value = [];
      let temp = JSON.stringify(item);
      this.submitForm = JSON.parse(temp);
      this.value.push(
        this.submitForm.parvince,
        this.submitForm.city,
        this.submitForm.area
      );
      this.edit = true;
    },
    //失败时的方法
    handleError(err) {
      this.$message.info(err.data);
    },
    //成功时的方法
    handleSuccess(response) {
      if (response.isSuccess) {
        this.$message.success(response.error);
        // this.getListByParam();
        return;
      }
      this.$message.info(response.error);
    },
    // 上传前
    handleBeforeUpload(file) {
      console.log(file);
      // 校验
      let legalName = ["xls"];
      // 拿到后缀名
      let name = file.name.substring(
        file.name.lastIndexOf(".") + 1,
        file.name.length
      );
      if (legalName.includes(name)) {
        // console.log(legalName.includes(name));
      } else {
        this.$message.info("文件格式不对，仅限后缀xls文件");
        return false;
      }
    },
    //上传
    uploadSectionFile(params) {
      console.log("file----", params)
      return
      let form = new FormData();
      form.append("file", params.file);
      this.axios
        .post(`/busFbx/uploadFbxJobsBoxInfo/${this.toFABck.id}`, form)
        .then((res) => {
          console.log(res);
          if (res.data.code == -1) {
            this.errorLabel = res.data.data;
            this.$message.info(res.data.data);
          } else {
            this.ruleform.formLIst = res.data.data;
            this.excelVisible = false;
            this.getTimoney(); //重新计算提货费
            this.getFBATrans(); //重新计算运输费
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
  created() {
    this.transportTypeCode = JSON.parse(
      sessionStorage.getItem("transportTypeCode")
    );
    if (sessionStorage.getItem("FBATransmoney")) {
      //提货地址
      this.FBATransmoney = JSON.parse(sessionStorage.getItem("FBATransmoney"));
    }
    if (sessionStorage.getItem("countLIst_T")) {
      //提货地址
      this.countLIst_T = JSON.parse(sessionStorage.getItem("countLIst_T"));
    }
    if (sessionStorage.getItem("todoorTime")) {
      //提货时间
      this.todoorTime = sessionStorage.getItem("todoorTime");
    }
    if (sessionStorage.getItem("boxLIst")) {
      //箱子
      this.ruleform.formLIst = JSON.parse(sessionStorage.getItem("boxLIst"));
    }
    if (sessionStorage.getItem("THFdata")) {
      // 提货费
      this.THFdata = JSON.parse(sessionStorage.getItem("THFdata"));
    }
  },
  mounted() {
    this.getGoodstypelist();
    this.getPopList();
    this.$nextTick(function () {
      //监听滚动
      window.addEventListener("scroll", this.onScroll);
    });
    let toFABck = JSON.parse(sessionStorage.getItem("toFABck"));
    if (toFABck.type == 1 && toFABck.countryCode == "SA") {
      //需要校验
      this.billType = true; //显示 商铺号和追踪号
      this.moreNotOjb.Notponum[0].required = true;
      this.moreNotOjb.Notgoodsnum[0].required = true;
      this.moreNotOjb.Notboxnum[0].required = true;
    } else if (toFABck.type == 1 && toFABck.countryCode != "SA") {
      this.billType = true;
      this.moreNotOjb.Notponum[0].required = false; //追踪号
      this.moreNotOjb.Notgoodsnum[0].required = false; //商铺号
      this.moreNotOjb.Notboxnum[0].required = true; //箱号校验
    }

    // this.billType = false
    // this.moreNotOjb.Notponum[0].required = false;
    // this.moreNotOjb.Notgoodsnum[0].required = false;
  },
};
</script>
<style scoped>
.helper {
  width: 100%;
  height: 15%;
  color: #FF4D01;
  align-content: center;
  text-align: center;
  font-size: 20px;
}

.box-card {
  position: relative;
}
.cardWrap {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  margin-top: 20px;
  border-radius: 8px;
}
.card_header {
  padding: 10px 20px;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 2px solid transparent;
  /* background: linear-gradient(white,white) padding-box,repeating-linear-gradient(-45deg, red 0, red 12.5%, transparent 0, transparent 25%, #58a 0, #FF4D01 37.5%, transparent 0, transparent 50%) 0/5em 5em; */
  /* border-bottom: 1px solid #DCDFE6; */
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.card_count {
  padding: 20px 20px 0 20px;
}
.addStyle {
  padding: 10px 0;
  box-sizing: border-box;
}
.header_logo {
  height: 30px;
  line-height: 30px;
  margin-left: 4px;
  color: #fff;
  position: absolute;
  top: 11px;
  right: 0px;
  border-radius: 20px 0px 0px 20px;
  background: #5643e6;
  font-weight: bold;
  border-style: none none solid solid;
  /* border-color: #83a4fe;
  border-width: 3px; */
  z-index: 999;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
}
.boxindex {
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #51ddd4;
  text-align: center;
  top: 16px;
  left: 4px;
  color: #ffffff;
  line-height: 16px;
  font-size: 12px;
  text-align: center;
}
.cloneType {
  color: #ffffff;
  float: left;
}
.deletebox {
  width: 60px;
  height: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  border-radius: 0 20px 20px 0;
  background: #51ddd4;
  font-weight: bold;
  border-style: solid solid none none;
  border-color: #f86670;
  border-width: 3px;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.3);
}
.deleteBtn {
  cursor: pointer;
  transition: all 0.2s ease-out;
  font-size: 18px;
  color: #ffffff;
  font-weight: bold;
  margin-left: 15px;
}
.TB_center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.fontString {
  font-weight: bold;
}
.auto_fixed {
  position: fixed;
  top: 20px;
  margin-left: 880px;
}
.goodsValue >>> .el-input__inner {
  border-radius: 0 !important;
  height: 24px !important;
  width: 100px !important;
  text-align: center;
  border: none;
  border-bottom: 1px solid #9999;
}
.handNumber >>> .el-input__inner {
  border-radius: 20px !important;
  height: 24px !important;
  width: 100px !important;
  text-align: center;
}
/* 去除 number类型 的自带默认箭头 */
.handNumber >>> .el-input__inner::-webkit-outer-spin-button,
.handNumber >>> .el-input__inner::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.handNumber >>> .el-input__inner[type="number"] {
  -moz-appearance: textfield;
}
.goodsTypeShow >>> .el-dialog__body {
  padding: 0 !important;
}
.table_wrap >>> .el-dialog__body {
  padding: 0 15px !important;
}
.card_header >>> .el-form-item {
  margin-bottom: 0px !important;
}
.Item_Right {
  float: left;
}
.Item_Right .tit {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
}
.littit {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
}
.goodLi {
  width: 100%;
  height: 30px;
  padding: 0px;
}
.coutText {
  margin-top: 9px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.Item_Right {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
.Iteminput {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  margin-bottom: 15px;
  color: #909399;
}
.center_wrap {
  width: 1200px;
  margin: 0 auto;
}
.Item_list {
  width: 100%;
  float: left;
  padding: 24px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
.header_wrap {
  width: 100%;
  height: 121px;
  margin-top: 33px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.wrap_l {
  float: left;
  width: 875px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 0 35px;
  box-sizing: border-box;
}
.wrap_R {
  float: right;
  width: 320px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  /* position: sticky;
  top: 0px; */
}
.cangkutit {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  float: left;
}
/* jack css start  */
/* 弹窗遮罩层 */
.dialogCover {
  width: 100%;
  height: 100%;
  background-color: rgba(88, 85, 85, 0.37);
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  z-index: 2000;
}
/* 弹窗 */
.myDialog {
  min-height: 350px;
  width: 50%;
  height: 50%;
  min-height: 400px;
  width: 50%;
  height: 50%;
  background-color: #fff;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  z-index: 2000;
  border-radius: 20px;
  padding: 20px;

  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.31);
}
/* 进一步查价 */
.redBtn {
  width: 159px;
  /* margin-top: 30px; */
  line-height: 53px;
  height: 53px;
  text-align: center;
  background: linear-gradient(-56deg, #ff3b2c 0%, #ff6a6a 100%);
  border-radius: 10px;
  color: #ffffff;
  cursor: pointer;
}
/* jack css end  */
</style>



// WEBPACK FOOTER //
// src/components/FBAorder/FbaCargo.vue